import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news24_1 from "../../images/news/news24_1.jpg";
import news24_2 from "../../images/news/news24_2.jpg";
import news24_3 from "../../images/news/news24_3.jpg";
import news24_4 from "../../images/news/news24_4.jpg";
import news24_5 from "../../images/news/news24_5.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news24 extends Component {
    componentDidMount() { }

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News24_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News24_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News24_LinkHome")}</Link>
                                </li>
                                <li>{t("News24_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News24_Content_H")}</h1>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news24_1}
                                                    alt=""
                                                />
                                            </div>

                                            {/* P1 */}
                                            <ReactMarkdown>{t("News24_P1_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news24_2}
                                                    alt={t("News24_IMG2_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News24_IMG2_DESC")}
                                                </div> 
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News24_P2_MD")}</ReactMarkdown>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News24_P3_MD")}</ReactMarkdown>

                                            {/* P4 */}
                                            <ReactMarkdown>{t("News24_P4_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news24_3}
                                                    alt={t("News24_IMG3_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News24_IMG3_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News24_P5_MD")}</ReactMarkdown>

                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news24_4}
                                                    alt={t("News24_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News24_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News24_P6_MD")}</ReactMarkdown>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News24_P7_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news24_5}
                                                    alt=""
                                                />
                                            </div>

                                            {/* P8 */}
                                            <ReactMarkdown>{t("News24_P8_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>

        );
    }
}

export default news24 = withTranslation()(news24);